/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import {
  VerifySuccessPageService,
  trackEvent,
  handleOutboundRedirect,
} from '../../../services';
import { VApplication } from '../../../application';
import { useTheme } from '../../../providers/theme';
import { useSMVerifyProductPage } from '../machines/pageContent';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import MiddleBlock from '../components/MiddleBlock';
import Image from 'react-bootstrap/Image';
import { useLocation } from 'react-router-dom';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.VerifySuccessPageService'
  ) as VerifySuccessPageService;
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const srv = getSrv();
  const location = useLocation();
  const { width, height, bp } = useViewport();
  const staticPageContentConfig = srv?.getStaticPageContent();
  const [buttonItem, setButtonItem] = useState();

  const { verifyProductPageState } = useSMVerifyProductPage({});
  const content = staticPageContentConfig?.CONTENT;

  useEffect(() => {
    trackEvent('VERIFY_SUCCESS', {
      linkName: 'verify_success_page',
    });
  }, []);

  const _renderTitle = () => {
    return (
      <>
        <div
          style={{
            fontSize: '36px',
            textAlign: 'center',
            fontWeight: 900,
          }}
          dangerouslySetInnerHTML={{
            __html: 'Congratulations!',
          }}
        />
        <div
          style={{
            fontSize: '24px',
            textAlign: 'center',
            fontWeight: 900,
            letterSpacing: '-1px',
          }}
          dangerouslySetInnerHTML={{
            __html: 'Your product has been verified.<br/> Enjoy!',
          }}
        />
      </>
    );
  };

  const _renderSubtitle = () => {
    return (
      <div
        style={{
          fontSize: '24px',
          textAlign: 'center',
          paddingTop: '40px',
        }}
        dangerouslySetInnerHTML={{
          __html: 'Learn more about our brands here',
        }}
      />
    );
  };

  const _renderButton = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingTop: '20px',
          cursor: 'pointer',
        }}
      >
        <div
          style={{
            background: '#2c2c2c',
            borderRadius: '50%',
            height: width * 0.2,
            width: width * 0.2,
            display: 'flex',
            justifyContent: 'center',
          }}
          onClick={() => {
            handleOutboundRedirect('https://in.thebar.com', 'thebar_button_success');
          }}
        >
          <img
            src='https://i.ibb.co/4K4PDkm/logo1-removebg-preview.png'
            width={'80%'}
            style={{ objectFit: 'contain' }}
          />
        </div>
      </div>
    );
  };

  const _renderFooter = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            textAlign: 'center',
            fontSize: '20px',
            fontFamily: 'KaushanScript-Regular',
            paddingTop: '15px',
          }}
          dangerouslySetInnerHTML={{ __html: 'Drink Responsibly' }}
        />
      </div>
    );
  };

  const _renderHeader = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          paddingLeft: '15px',
          paddingRight: '15px',
          paddingBottom: '5px',
          background: 'transparent',
        }}
      >
        <img
          src={'https://i.ibb.co/4Rk09qm/logo-removebg-preview.png'}
          width={'40%'}
          style={{ cursor: 'pointer', objectFit: 'contain' }}
          onClick={() => {
            handleOutboundRedirect('https://www.diageo.com/', 'diageo_header_logo_success');
          }}
        />
        <img
          src='https://i.ibb.co/7ncNjc2/thebar.png'
          width={'40%'}
          style={{ cursor: 'pointer', objectFit: 'contain' }}
          onClick={() => {
            handleOutboundRedirect('https://in.thebar.com', 'thebar_header_logo_success');
          }}
        />
      </div>
    );
  };

  const _renderCaroselImage = () => {
    return (
      <div>
        <img src='https://i.ibb.co/mJfYQVb/hero-image-1-1.jpg' />
      </div>
    );
  };

  const _renderIcon = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '10% 10% 0 10%',
        }}
      >
        <img
          src='https://i.ibb.co/W603kmK/congrats-icon.png'
          width={'20%'}
          height={'20%'}
        />
      </div>
    );
  };

  return (
    <>
      <div style={{ height: '100vh', background: '#F9F0EB' }}>
        {_renderHeader()}
        {_renderCaroselImage()}
        {_renderIcon()}
        {_renderTitle()}
        {_renderSubtitle()}
        {_renderButton()}
        {_renderFooter()}
      </div>
    </>
  );
};
